import {useNavigate} from "react-router-dom";
import Box from "@mui/material/Box";
import Typography from "@mui/material/Typography";
import Grid from "@mui/material/Grid";
import PageTitle from "shared/ui/PageTitle";
import CustomButton from "shared/ui/CustomButton";

const ACCOUNTS = [
    {
        imageUrl: "/images/account-type-1.svg",
        loginText: "Creează cont școală/Centru de meditație",
        loginUrl: "/login/scoala",
        aboutUrl: "/despre-cont-scoala",
        aboutText: "Despre BRIO pentru școli",
        sxExtra: {whiteSpace: "wrap"},
    },
    {
        imageUrl: "/images/account-type-2.svg",
        loginText: " Creează cont profesor",
        loginUrl: "/login/profesori",
        aboutUrl: "/despre-cont-profesor",
        aboutText: "Despre BRIO pentru profesor",
        sxExtra: {},
    }
]

const AccountType = () => {
    const navigate = useNavigate();

    return (
        <Box component="main">
            <PageTitle>
                BRIO pentru școli și profesori
            </PageTitle>
            <Typography variant="body1">
                În procesul de digitalizare dedicat școlilor și elevilor, Brio® este o componentă esențială cu rolul de
                a optimiza și de a crește performanța. Din acest an, evaluarea în școli se face pe baza standardelor
                naționale adoptate prin lege și obligatorii la clasă, iar testele Brio (clasele I - VIII) sunt adaptate
                la acestea.
            </Typography>
            <Typography variant="h3" mt={3} mb={3}>Alege tipul contului</Typography>
            <Typography variant="body1" mb={3}>
                Brio® îți arată nivelul (real) de cunoștințe al elevului prin intermediul raportului detaliat de
                evaluare care îți spune care sunt capitolele la care elevul excelează și care sunt cele care necesită
                îmbunătățiri, monitorizând progresul prin retestare.
            </Typography>
            <Typography variant="body1" fontWeight="bold">
                Cine folosește Brio®:
            </Typography>
            <ul style={{marginTop: 0}}>
                <li>Școlile de stat și private/Centrele de meditații</li>
                <li>Profesorii</li>
            </ul>
            <Grid container direction="row" spacing={6} justifyContent="center" alignContent="strech">
                {ACCOUNTS.map((account, index: number) => (
                    <Grid key={index} item xs={12} md={6} xl={5}>
                        <Box
                            display="flex"
                            flexDirection="column"
                            sx={{
                                backgroundColor: "background.paper",
                                padding: {xs: 1.5, md: 3},
                                borderRadius: 1.5,
                                height: "100%"
                            }}
                        >
                            <img
                                src={account.imageUrl}
                                height="200px"
                                style={{width: "auto", marginBottom: 30}}
                                alt="Brio Platforma de Testare Fundamentată Științific"
                            />
                            <CustomButton
                                buttonType="textIcon"
                                onClick={() => {
                                    navigate(account.loginUrl)
                                }}
                            >
                                {account.loginText}
                            </CustomButton>
                            <Box mt={2}></Box>
                            <CustomButton
                                buttonType="textIconOutlined"
                                color="info.contrastText"
                                borderColor="info.contrastText"
                                bgcolor="modal"
                                sxExtra={{borderRadius: 1}}
                                onClick={() => {
                                    navigate(account.aboutUrl)
                                }}
                            >
                                {account.aboutText}
                            </CustomButton>
                        </Box>
                    </Grid>
                ))}
            </Grid>
        </Box>
    )
};

export default AccountType;